import { useState } from "react"
import { useDispatch } from "react-redux"
import "./index.scss"

import DropdownButton from "react-bootstrap/DropdownButton"
import DropdownItem from "react-bootstrap/DropdownItem"
import Button from "react-bootstrap/Button"
import { message } from "state_management"
import useT from "utils/hooks/useT"

// Performer constraints component.
// Tasks/actions are under the common name "tasks"
export default function PerformerConstraints({ tasks, performerConstraints, onConstraintsChange, isProject = false }) {
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const [firstConstraintTaskId, setFirstConstraintTaskId] = useState(null)
  const [secondConstraintTaskId, setSecondConstraintTaskId] = useState(null)
  const [performerConstraintValue, setPerformerConstraintValue] = useState("SAME")

  const firstIdName = isProject ? "firstId" : "firstDefinitionId"
  const secondIdName = isProject ? "secondId" : "secondDefinitionId"
  const dispatch = useDispatch()
  return (
    <div className="PerformerConstraints-container">
      <div className="PerformerConstraints-selector">
        <DropdownButton
          bsPrefix="CustomButtonStyle btn"
          className="PerformerContraints-item"
          title={
            tasks[firstConstraintTaskId]
              ? tc("namePerformer", { name: tasks[firstConstraintTaskId].name })
              : isProject ? tc("chooseAction") : tc("chooseTask")
          }
          onSelect={(id) => setFirstConstraintTaskId(id)}
        >
          {Object.values(tasks)
            .sort((a, b) => {
              if (a.name.toUpperCase() < b.name.toUpperCase()) return -1
              if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
              return 0
            })
            .map((task) => (
              <DropdownItem type="button" key={task.id} eventKey={task.id} as="button">
                {tc("namePerformer", { name: task.name })}
              </DropdownItem>
            ))}
        </DropdownButton>
        <DropdownButton
          bsPrefix="CustomButtonStyle btn"
          className="PerformerContraints-item"
          title={performerConstraintValue === "SAME" ? tc("shouldBeEqualTo") : tc("shouldNotBeEqualTo")}
          onSelect={(id) => setPerformerConstraintValue(id)}
        >
          <DropdownItem type="button" eventKey="SAME" as="button">
            {tc("shouldBeEqualTo")}
          </DropdownItem>
          <DropdownItem type="button" eventKey="DIFFERENT" as="button">
            {tc("shouldNotBeEqualTo")}
          </DropdownItem>
        </DropdownButton>
        <DropdownButton
          bsPrefix="CustomButtonStyle btn"
          className="PerformerContraints-item"
          title={
            tasks[secondConstraintTaskId]
              ? tc("namePerformer", { name: tasks[secondConstraintTaskId].name })
              : isProject
              ? tc("chooseAction")
              : tc("chooseTask")
          }
          onSelect={(id) => setSecondConstraintTaskId(id)}
        >
          {Object.values(tasks).map((task) => (
            <DropdownItem type="button" key={task.id} eventKey={task.id} as="button">
              {tc("namePerformer", { name: task.name })}
            </DropdownItem>
          ))}
        </DropdownButton>
        <Button
          title={tc("addConstraint")}
          variant="primary"
          size="sm"
          className="add-performer-constraint-btn"
          onClick={(_e) => {
            if (!tasks[firstConstraintTaskId]) {
              dispatch(message.warning(t("adhoc.chooseFirstAction", { itemType: isProject ? "action" : "task" })))
              return
            }
            if (!tasks[secondConstraintTaskId]) {
              dispatch(message.warning(t("adhoc.chooseSecondAction", { itemType: isProject ? "action" : "task" })))
              return
            }
            if (firstConstraintTaskId === secondConstraintTaskId) {
              dispatch(message.warning(t("adhoc.chooseTwoDifferent", { itemType: isProject ? "actions" : "tasks" })))
              return
            }

            if (
              performerConstraints.find(
                (performerConstraint) =>
                  (performerConstraint[`${firstIdName}`] === firstConstraintTaskId &&
                    performerConstraint[`${secondIdName}`] === secondConstraintTaskId) ||
                  (performerConstraint[`${firstIdName}`] === secondConstraintTaskId &&
                    performerConstraint[`${secondIdName}`] === firstConstraintTaskId)
              )
            ) {
              dispatch(message.warning(t("adhoc.constraintConflicts")))
              return
            }
            // TODO: Check for duplicates
            var constraint = {}
            if (isProject) {
              constraint = {
                firstId: firstConstraintTaskId,
                secondId: secondConstraintTaskId,
                performerConstraint: performerConstraintValue,
              }
            } else {
              constraint = {
                firstDefinitionId: firstConstraintTaskId,
                secondDefinitionId: secondConstraintTaskId,
                performerConstraint: performerConstraintValue,
              }
            }

            onConstraintsChange(performerConstraints.concat([constraint]))
          }}
        >
          {tc("add")}
        </Button>
      </div>

      <div className="PerformerConstraints-holder">
        {!!performerConstraints.length &&
          performerConstraints.map((constraint, idx) => (
            <div key={idx}>
              <span>
                {tc("namePerformer", { name: tasks[constraint[`${firstIdName}`]].name })}{" "}
                {constraint.performerConstraint === "SAME" ? tc("shouldBeEqualTo") : tc("shouldNotBeEqualTo")}{" "}
                {tc("namePerformer", { name: tasks[constraint[`${secondIdName}`]].name })}
              </span>
              <Button
                className="remove-performer-constraint-btn"
                title={tc("deleteConstraint")}
                variant="danger"
                size="sm"
                onClick={() =>
                  onConstraintsChange(performerConstraints.slice(0, idx).concat(performerConstraints.slice(idx + 1)))
                }
              >
                {tc("remove")}
              </Button>
            </div>
          ))}
      </div>
    </div>
  )
}
